import { GeochemicalRunDTO } from './GeochemicalRunDTO'
import { GeochemicalRun } from './GeochemicalRunModel'

export const mapGeochemicalRunModel = (geochemicalRunDTO: GeochemicalRunDTO): GeochemicalRun => {
    return geochemicalRunDTO as GeochemicalRun
}
